import { RequestDocumentDto } from './request-documents.dto';
import { EpimsBaseEntityDto } from './epim-base.dto';

export class RequestResponseDto extends EpimsBaseEntityDto {
  RequestId: string;
  ResponseEmail: string;
  DocUrl: string;
  DocName: string;
  Documents: RequestDocumentDto[];
  Response: string;
}
